import gql from 'graphql-tag'

export const CREATE_CONTRAT = gql`
 mutation($interimaireId: Int!,
  $raison: String, $dateDebut: Datetime, 
  $dateFin: Datetime, $iadeId: Int, $tauxBrut: BigFloat){
    createContratsInterim(input: {
      contratsInterim:{
        interimaireId: $interimaireId
        raison: $raison
        dateDebut: $dateDebut
        dateFin: $dateFin
        iadeId: $iadeId
        tauxBrut: $tauxBrut
      }
    }){
      contratsInterimEdge{
        node
       { 
        id
        raison
        dateDebut
        dateFin
        tauxBrut
        }
      }
    }
  }
  `
// insert into contrats_interim () values()
export const DELETE_CONTRAT = gql`
  mutation ($id: Int!){
    deleteContratsInterimById(
      input: {
        id: $id
      }) {
    deletedContratsInterimId
    contratsInterim {
      id
    }
  }
}
`
export const ALL_CONTRATS = gql`
query($first: Int!, $offset: Int!){
    allContratsInterims(first: $first, offset: $offset, orderBy: ID_DESC){
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
        edges{       
          node{        
            id
            interimaireId 
            createdAt
            updatedAt
            raison
            tauxBrut
            dateDebut
            dateFin
            interimaireByInterimaireId
            {
              id
              nom
              prenom
              numss
              dateNaiss
              departementNaiss
              adresse
              lieuNaiss
              nationalite
              salutation
            }
            iadeByIadeId{
              nom
              prenom
              id
            }
          }
        }
      }
    }
    `
export const UPDATE_CONTRAT = gql`
  mutation($id: Int!, $dateDebut: Datetime, 
    $dateFin: Datetime, $raison: String, $tauxBrut: BigFloat){
    updateContratsInterimById(input:{
      id: $id
      contratsInterimPatch:{
        dateDebut:   $dateDebut
        dateFin:   $dateFin
        raison:   $raison
        tauxBrut: $tauxBrut
      }
    }){
      contratsInterim{
        interimaireId
        iadeId
        tauxBrut
        raison
        dateDebut
        dateFin
      }
    }
  }
  `

export const CONTRAT_BY_ID_QUERY = gql`
  query contratInterimById($id: Int!){
    contratsInterimById(id: $id){
      id
      interimaireId
      iadeId
      interimaireByInterimaireId{
        id
        nom
        prenom
        
      }
      iadeByIadeId{
        id
        nom
        prenom
      
      }
    dateDebut
    dateFin
    raison
    tauxBrut
    }
  }
    `



// WEBPACK FOOTER //
// ./src/constants/contratsInterim.js